/**
 * Campaign area route paths more than one file depends on: a screen's own
 * `routes.ts` registers them, and a page that links to another screen needs
 * the same literal, not a second copy of it to drift from the registration
 * (`../control/paths.ts` exists at the control-plane level for the identical
 * reason).
 *
 * Relative to the router's `basepath`, like every other route literal in this
 * plane.
 */

import { interpolatePath } from '@tanstack/react-router';

export const TEAMS_PATH = '/c/$campaignId/teams';

/** `TEAMS_PATH` filled in, for a caller outside this area that needs a plain
 *  href rather than a typed `<Link>`. */
export function teamsPath(campaignId: string): string {
  return interpolatePath({ path: TEAMS_PATH, params: { campaignId } }).interpolatedPath;
}
